import ActionTypes from "../actionTypes/actionTypes";

export default (state = null, action) => {
    switch (action.type) {
        case ActionTypes.MANAGE_THEME : {
            return action.theme
        }
        default:
            return state        
    }
}